export default "__VITE_ASSET__CqWNlIif__"